import { useEffect, useRef, useState } from 'react';

interface AccordionContentProps {
  children: React.ReactNode;
  open: boolean;
  bgColor?: string;
}

export const AccordionContent = ({
  open,
  children,
  bgColor = 'bg-white',
}: AccordionContentProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (open) {
      setContentHeight(contentRef.current?.scrollHeight ?? 0);
    } else {
      setContentHeight(0);
    }
  }, [open, children]);

  // Observe size changes while open (e.g., inner accordions expand)
  useEffect(() => {
    if (!contentRef.current) return;
    const node = contentRef.current;
    const observer = new ResizeObserver(() => {
      if (open) {
        setContentHeight(node.scrollHeight);
      }
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [open]);

  return (
    <div
      ref={containerRef}
      className="overflow-hidden transition-all duration-300 ease-out"
      style={{
        height: open ? `${contentHeight}px` : '0px',
      }}
    >
      {open && (
        <div ref={contentRef} className={`px-4 py-2 ${bgColor}`}>
          {children}
        </div>
      )}
    </div>
  );
};
